import { getFormattedLabel } from 'alurkerja-ui'

export type CustomDisplayNameLayerType = (params: {
  component: any
  index: number
  language?: string
  parentComponent?: any
  default: (params: DisplayNameLayerType) => string
}) => string

export type DisplayNameLayerType = {
  component: any
  index: number
  language?: string
  parentComponent?: any
}

export const getDisplayName = ({ component, index, language }: DisplayNameLayerType) => {
  if (typeof component?.label === 'object') {
    return getFormattedLabel(component?.label, language)
  }
  if (component?.content) {
    if (typeof component?.content === 'object') {
      return getFormattedLabel(component?.content, language)
    }
    if (typeof component?.content === 'string') {
      return component.content
    }
  }

  if (component?.ui_type) {
    if (component?.ui_type === 'FORM2X2') {
      return 'Layout Grid 2X2'
    }
    if (component?.ui_type === 'FORM2X3') {
      return 'Layout Grid 2X3'
    }
    if (component?.ui_type == 'DIV') {
      if (component.className.includes('flex-col')) {
        return 'Layout Column'
      } else {
        return 'Layout Row'
      }
    }
    return component.ui_type
  }

  return index ? 'Right' : 'Left'
}
